import { supabase } from '../config/supabase';

export interface SplitOversizedJobResult {
  parent_job_id: string;
  split_group_id: string;
  child_job_ids: string[];
  vehicle_count: number;
}

export async function splitOversizedJob(
  jobId: string,
  maxCapacity: number,
  passengerCounts: number[]
): Promise<SplitOversizedJobResult> {
  const { data, error } = await supabase.rpc('split_oversized_job', {
    p_job_id: jobId,
    p_max_capacity: maxCapacity,
    p_passenger_counts: passengerCounts,
  });

  if (error) throw error;

  const row = data as {
    parent_job_id: string;
    split_group_id: string;
    child_job_ids: string[];
    vehicle_count: number;
  };

  return {
    parent_job_id: row.parent_job_id,
    split_group_id: row.split_group_id,
    child_job_ids: row.child_job_ids ?? [],
    vehicle_count: row.vehicle_count,
  };
}
